import { Link } from "react-router-dom";
import ArticleCard, { CategoryTag } from "@/components/feature/ArticleCard";
import { articles, featuredArticles, hotArticles } from "@/mocks/articles";

export default function HeroSection() {
  const lead = featuredArticles[0] ?? articles[0];
  const secondary = articles.filter((item) => item.id !== lead.id).slice(0, 2);
  const board = [...hotArticles].sort((a, b) => b.views - a.views).slice(0, 5);

  return (
    <section aria-label="今日头条" className="mx-auto max-w-content px-4 pt-6 md:px-6 md:pt-8">
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <div className="rise-in">
            <ArticleCard article={lead} variant="hero" />
          </div>
          <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2">
            {secondary.map((item) => (
              <div
                key={item.id}
                className="rounded-lg border border-background-200 bg-background-50 p-4"
              >
                <div className="flex items-center gap-2">
                  <CategoryTag slug={item.categorySlug} name={item.category} />
                  <span className="text-[11px] text-foreground-500">{item.date}</span>
                </div>
                <h3 className="mt-3 font-heading text-base font-semibold leading-snug text-foreground-950">
                  <Link
                    to={`/article/${item.id}`}
                    className="cursor-pointer transition-colors hover:text-primary-600"
                  >
                    {item.title}
                  </Link>
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                  {item.excerpt}
                </p>
              </div>
            ))}
          </div>
        </div>

        <aside className="lg:col-span-4">
          <div className="h-full rounded-lg border border-background-200 bg-background-100 p-5">
            <div className="flex items-center justify-between">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <span className="flex h-5 w-5 items-center justify-center text-primary-500">
                  <i className="ri-fire-fill"></i>
                </span>
                今日爆料热榜
              </h3>
              <a
                href="#ranking"
                className="cursor-pointer whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-primary-600"
              >
                完整榜单
              </a>
            </div>

            <ol className="mt-4 space-y-1">
              {board.map((item, index) => (
                <li key={item.id} className="flex items-start gap-3 border-b border-background-200 py-3 last:border-0">
                  <span
                    className={`flex h-6 w-6 flex-none items-center justify-center rounded-md font-heading text-xs font-bold ${
                      index < 3
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    {index + 1}
                  </span>
                  <div className="min-w-0">
                    <h4 className="font-heading text-sm font-medium leading-snug text-foreground-900">
                      <Link
                        to={`/article/${item.id}`}
                        className="cursor-pointer transition-colors hover:text-primary-600"
                      >
                        {item.title}
                      </Link>
                    </h4>
                    <div className="mt-1.5 flex items-center gap-3 text-[11px] text-foreground-500">
                      <span>{item.category}</span>
                      <span className="flex items-center gap-1">
                        <span className="flex h-3.5 w-3.5 items-center justify-center">
                          <i className="ri-eye-line"></i>
                        </span>
                        {(item.views / 1000).toFixed(1)}k
                      </span>
                    </div>
                  </div>
                </li>
              ))}
            </ol>

            <div className="mt-5 rounded-md bg-secondary-950 p-4">
              <p className="flex items-center gap-2 text-xs font-medium tracking-widest text-accent-400">
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-information-line"></i>
                </span>
                阅读提示
              </p>
              <p className="mt-2 text-xs leading-relaxed text-background-300">
                本站内容基于公开信息与行业观察整理，涉及人物一律匿名表述，请理性看待，不信谣不传谣。
              </p>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}